import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'
import ManageTable from '../../elements/ManageTable'
import upArrow from '../../media/icons/icons8-up-96.png'
import downArrow from '../../media/icons/icons8-down-96.png'
import leftArrow from '../../media/icons/icons8-left-96.png'
import rightArrow from '../../media/icons/icons8-right-96.png'

const Main = (props) => {

    function getCurrentTimeFormatted() {
        const now = new Date();
  
        let hours = now.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        
        hours = hours % 12; // Convert to 12-hour format
        hours = hours ? hours : 12; // The hour '0' should be '12'
        
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
      
        return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    }

    const [users, setUsers] = useState([])

    const [orderTableTitles, setOrderTableTitles] = useState([
        {
            title: 'Order #',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
        {
            title: 'Move',
            displayElement: (props) => (<div style={{display: 'flex', flexDirection: 'row'}}>
                <IconButton colors={props.colors} onClick={() => moveUser(props, -1)} image={upArrow} size={26} Style={{marginRight:'5px'}}></IconButton>
                <IconButton colors={props.colors} onClick={() => moveUser(props, 1)} image={downArrow} size={26}></IconButton>
            </div>),
            default: '',
        },
        {
            title: 'Move To',
            displayElement: (props) => (<TextInput onKeyDown={(e) => e.key === 'Enter' ? moveUserSetLocation(props, props.data):''} onChange={(e) => onOrderTableChange(e, props.index, props.indexParent, props.tableData, props.tableIDs)} data={props.data} width={'75px'} colors={props.colors} style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}></TextInput>),
            default: '',
        },
        {
            title: 'User',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
    ])

    const [metricTableTitlesAssigned, setMetricTableTitlesAssigned] = useState([
        {
            title: 'Move',
            displayElement: (props) => (<div style={{display: 'flex', flexDirection: 'row'}}>
                <IconButton colors={props.colors} onClick={() => changeUserAssignment(props, 0)} image={rightArrow} size={26}></IconButton>
            </div>),
            default: '',
        },
        {
            title: 'User',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
    ])

    const [metricTableTitlesUnassigned, setMetricTableTitlesUnassigned] = useState([
        {
            title: 'Move',
            displayElement: (props) => (<div style={{display: 'flex', flexDirection: 'row'}}>
                <IconButton colors={props.colors} onClick={() => changeUserAssignment(props, 1)} image={leftArrow} size={26}></IconButton>
            </div>),
            default: '',
        },
        {
            title: 'User',
            displayElement: (props) => (<span style={{marginLeft: '30px', marginRight: '30px', whiteSpace: 'nowrap'}}>{props.data}</span>),
            default: '',
        },
    ])

    const [orderTableValues, setOrderTableValues] = useState([
        [orderTableTitles[0].default], 
        [orderTableTitles[1].default],
        [orderTableTitles[2].default],
        [orderTableTitles[3].default],
        // [tableTitles[3].default],
    ])

    const [orderTableData, setOrderTableData] = useState([
        [orderTableTitles[0].default],
        [orderTableTitles[1].default],
        [orderTableTitles[2].default],
        [orderTableTitles[3].default],
        // [tableTitles[3].default],
    ])

    const [metricTableValuesAssigned, setMetricTableValuesAssigned] = useState([
        [metricTableTitlesAssigned[0].default], 
        [metricTableTitlesAssigned[1].default],
    ])

    const [metricTableDataAssigned, setMetricTableDataAssigned] = useState([
        [metricTableTitlesAssigned[0].default], 
        [metricTableTitlesAssigned[1].default],
    ])

    const [metricTableValuesUnassigned, setMetricTableValuesUnassigned] = useState([
        [metricTableTitlesUnassigned[0].default], 
        [metricTableTitlesUnassigned[1].default],
    ])

    const [metricTableDataUnassigned, setMetricTableDataUnassigned] = useState([
        [metricTableTitlesUnassigned[0].default], 
        [metricTableTitlesUnassigned[1].default],
    ])

    const [orderDropdownData, setOrderDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [[]],
    ])

    const [metricAssignedDropdownData, setMetricAssignedDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [[]],
    ])

    const [metricUnassignedDropdownData, setMetricUnassignedDropdownData] = useState([
        [[]],
        [[]],
        [[]],
        [[]],
    ])

    const [rowSelected, setRowSelected] = useState([false])
    
    const onMetricUnassignedTableChange = (e, y, x, tableValuesIn, tableDataIn) => {
        console.log('Table Updated', e, x, y)
        setMetricTableValuesUnassigned(() => tableValuesIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.label;
                }
                return data;
            })
        }))
        setMetricTableDataUnassigned(() => tableDataIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.value;
                }
                return data;
            })
        }))
    }

    const onMetricAssignedTableChange = (e, y, x, tableValuesIn, tableDataIn) => {
        console.log('Table Updated', e, x, y)
        setMetricTableValuesAssigned(() => tableValuesIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.label;
                }
                return data;
            })
        }))
        setMetricTableDataAssigned(() => tableDataIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.value;
                }
                return data;
            })
        }))
    }

    const onOrderTableChange = (e, y, x, tableValuesIn, tableDataIn) => {
        console.log('Table Updated', e, x, y)
        setOrderTableValues(() => tableValuesIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.label;
                }
                return data;
            })
        }))
        setOrderTableData(() => tableDataIn.map((column, indexParent) => {
            return column.map((data, index) => {
                if (index === y && indexParent === x)
                {
                    if (e.label === undefined)
                    {
                        return e;
                    }
                    return e.value;
                }
                return data;
            })
        }))
    }

    const [data, setData] = useState({
        metric: {value: 'order', label: 'Order'},
    })

    const onDataChange = (e, value) => {
        setData(prevData => ({
            ...prevData,
            [value]: e
        }))
        if (value === 'metric')
        {
            loadMetricUsers(e.value);
        }
    }

    useEffect(() => {
        console.log(data)
        if (data.metric.value === 'order')
        {
            //get dealers
            var myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
            myHeaders.append("Content-Type", "application/json");
            
            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            }

            const roles = ['subagent', 'management']

            props.tokenSafeAPIRequest('/metrics/metadata/order', requestOptions, '', (result) => {
                console.log(result)
                let tempUserList = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                let tempUserListValues = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                result.map((user, index) => {
                {
                    tempUserList[0].push(index)
                    tempUserList[1].push(user)
                    tempUserList[2].push('')
                    tempUserList[3].push(user.name)

                    tempUserListValues[0].push(index)
                    tempUserListValues[1].push(user)
                    tempUserListValues[2].push('')
                    tempUserListValues[3].push(user.id)
                }})
                setOrderTableData(tempUserListValues)
                setOrderTableValues(tempUserList)
            }) 
        }
    },[data.metric])

    const generateKey = () => {
        let tempNum = Math.random() * 100000
        return (Math.round(tempNum) + 'F') ;
    }

    const loadMetricUsers = (metricName) => {
        if (metricName !== 'order')
        {
            var myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");
            myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
            myHeaders.append("Content-Type", "application/json");
            
            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow',
            }

            props.tokenSafeAPIRequest('/metrics/metadata/' + metricName + '/visible', requestOptions, '', (result) => {
                let tempUserList = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                let tempUserListValues = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                result.map((user, index) => {
                {
                    tempUserList[0].push(user)
                    tempUserList[1].push(user.name)

                    tempUserListValues[0].push(user)
                    tempUserListValues[1].push(user.id)
                }})
                console.log(tempUserList)
                setMetricTableDataAssigned(tempUserListValues)
                setMetricTableValuesAssigned(tempUserList)
            })

            props.tokenSafeAPIRequest('/metrics/metadata/' + metricName + '/invisible', requestOptions, '', (result) => {
                let tempUserList = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                let tempUserListValues = [
                    [],
                    [],
                    [],
                    [],
                    // [],
                ]
                result.map((user, index) => {
                {
                    tempUserList[0].push(user)
                    tempUserList[1].push(user.name)

                    tempUserListValues[0].push(user)
                    tempUserListValues[1].push(user.id)
                }})
                console.log(tempUserList)
                setMetricTableDataUnassigned(tempUserListValues)
                setMetricTableValuesUnassigned(tempUserList)
            })
        }
    }

    const options = [
        {value: 'CombinedSubagentReport', label: 'Combined Subagent Report'},
        {value: 'MonthlySheet',           label: 'Monthly Sheets'},
        {value: 'PayrollSheet',           label: 'Payroll Sheets'},
        {value: 'BestMonthEver',          label: 'Agents Best Month'},
        {value: 'CCByAdmin',              label: 'Contract Count by Admin'},
        {value: 'CCByAgent',              label: 'Contract Count by Agent'},
        {value: 'TotalAgentNet',          label: 'Total Agent Net'},
        {value: 'McCreadySheet',          label: 'McCready Agent Net'},
        {value: 'order', label: 'Order'},
    ]

    const saveMetric = (metricName) => {

        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
        myHeaders.append("Content-Type", "application/json");

        if (metricName === 'order')
        {
            console.log('Saving Order')
            var requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                redirect: 'follow',
                body: JSON.stringify(orderTableData[3])
            }

            props.tokenSafeAPIRequest('/metrics/metadata/order', requestOptions, '', (result, status) => {
                if (status === 200)
                {
                    props.setNotification( getCurrentTimeFormatted() + ': Updated All Metric Order Sucessfully!')
                } else {props.setNotification(props.getServerResponse(result))}
            })
        }
        else
        {
            console.log('Saving metric: ' + metricName)
            var requestOptions = {
                method: 'PUT',
                headers: myHeaders,
                redirect: 'follow',
                body: JSON.stringify(metricTableDataAssigned[1])
            }

            props.tokenSafeAPIRequest('/metrics/metadata/' + metricName + '/visible', requestOptions, '', (result, status) => {
                if (status === 200)
                {
                    props.setNotification( getCurrentTimeFormatted() + ': Updated Metric Visibility Sucessfully!')
                } else {props.setNotification(props.getServerResponse(result))}
            })
        }
    }

    const moveUser = (props, direction) => {
        console.log(props)

        if (direction !== 1 && direction !== -1) return props.tableIDs;

        const index = props.tableIDs[3].indexOf(props.data.id);
        if (index === -1) return props.tableIDs;

        const newIndex = index + direction;
        if (newIndex < 0 || newIndex >= props.tableIDs[3].length) return props.tableIDs;

        let newTableData = props.tableIDs.map((arr, i) => {
            if (i === 0) return [...arr]; // untouched copy

            const copy = [...arr];
            [copy[index], copy[newIndex]] = [copy[newIndex], copy[index]];
            return copy;
        });

        let newTableValues = props.tableData.map((arr, i) => {
            if (i === 0) return [...arr]; // untouched copy
            
            const copy = [...arr];
            [copy[index], copy[newIndex]] = [copy[newIndex], copy[index]];
            return copy;
        })

        setOrderTableData(newTableData)
        setOrderTableValues(newTableValues)
    };

    const moveUserSetLocation = (props, targetIndex) => {
        console.log(props, targetIndex)
        // find where the user currently is (using the same row you used before)
        const currentIndex = props.index
        console.log(currentIndex)
        if (currentIndex === -1) return props.tableIDs;

        // bounds + no-op
        if (targetIndex < 0 || targetIndex >= props.tableIDs[1].length) return props.tableIDs;
        if (targetIndex === currentIndex) return props.tableIDs;

        const moveInAllRows = (rows) =>
            rows.map((arr, i) => {
            if (i === 0) return [...arr]; // keep your "header/untouched" rule

            const copy = [...arr];
            const [item] = copy.splice(currentIndex, 1);
            copy.splice(targetIndex, 0, item);
            return copy;
            });

        const newTableData = moveInAllRows(props.tableIDs);
        const newTableValues = moveInAllRows(props.tableData);

        setOrderTableData(newTableData);
        setOrderTableValues(newTableValues);

        return newTableData;
    };

    const changeUserAssignment = (props, direction) => {

        const removeById = (prev, id) => {
            const index = prev[0].findIndex(item => item.id === id);
            if (index === -1) return prev;

            return [
                prev[0].filter((_, i) => i !== index),
                prev[1].filter((_, i) => i !== index),
            ];
        };

        if (direction === 0)
        {
            //0 = assign to unassign
            console.log('assigned to unassigned');

            // add to unassigned
            setMetricTableDataUnassigned(prev => {
            const next = [...prev];
            next[0] = [props.data, ...prev[0]];
            next[1] = [props.data.id, ...prev[1]];
            return next;
            });

            setMetricTableValuesUnassigned(prev => {
            const next = [...prev];
            next[0] = [props.data, ...prev[0]];
            next[1] = [props.data.name, ...prev[1]];
            return next;
            });

            // remove from assigned
            setMetricTableValuesAssigned(prev => removeById(prev, props.data.id));
            setMetricTableDataAssigned(prev => removeById(prev, props.data.id));
        }
        else if (direction === 1)
        {
            console.log('unassigned to assign')
            //1 = unassign to assign
            setMetricTableDataAssigned(prev => {
                const next = [...prev];
                next[0] = [props.data, ...prev[0]];
                next[1] = [props.data.id, ...prev[1]];
                console.log(next)
                return next;
            });

            setMetricTableValuesAssigned(prev => {
                const next = [...prev];
                next[0] = [props.data, ...prev[0]];
                next[1] = [props.data.name, ...prev[1]];
                console.log(next)
                return next;
            });

            setMetricTableValuesUnassigned(prev => {
                return removeById(prev, props.data.id);
            });
            setMetricTableDataUnassigned(prev => {
                return removeById(prev, props.data.id);
            });
        }
    }

    return (
        <div style={{width: '1500px', height: 'auto', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>Manage User Order</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '90%', display: 'flex', flexDirection: 'column', marginTop: '20px'}}>
                <Button onClick={() => saveMetric(data.metric.value)} colors={props.colors} active={true} Style={{width: '150px', marginTop: '0px'}}>Save</Button>
                <span onClick={() => console.log(metricTableValuesUnassigned)} style={{fontSize: '18px', fontWeight: '600', marginBottom: '10px', marginTop: '20px'}}>Metric</span>
                <Dropdown colors={props.colors} onChange={(e) => onDataChange(e, 'metric')} index={props.index} indexParent={props.indexParent} data={options} width={'300px'} value={data.metric.label}></Dropdown>
                <div style={{display: 'flex', flexDirection: 'row', marginTop: '20px'}}>
                    <div style={{flexBasis: '50%', display: 'flex', flexDirection: 'column'}}>
                        <span style={{fontSize: '18px', fontWeight: '600', marginBottom: '10px'}}>Assigned Users</span>
                        {data.metric.label === 'Order' && <ManageTable colors={props.colors} tableData={orderTableValues} tableInfo={orderTableTitles} keys={generateKey()} tableIDs={orderTableData} dropdownData={orderDropdownData} onChange={onOrderTableChange} selectMenu={false} onBottom={() => ''}></ManageTable>}
                        {data.metric.label !== 'Order' && <ManageTable colors={props.colors} tableData={metricTableValuesAssigned} tableInfo={metricTableTitlesAssigned} keys={generateKey()} tableIDs={metricTableDataAssigned} dropdownData={metricAssignedDropdownData} onChange={onMetricAssignedTableChange} selectMenu={false} onBottom={() => ''}></ManageTable>}
                    </div>
                    {data.metric.label !== 'Order' && <div style={{flexBasis: '50%', display: 'flex', flexDirection: 'column'}}>
                        <span style={{fontSize: '18px', fontWeight: '600', marginBottom: '10px'}}>Unassigned Users</span>
                        <ManageTable colors={props.colors} tableData={metricTableValuesUnassigned} tableInfo={metricTableTitlesUnassigned} keys={generateKey()} tableIDs={metricTableDataUnassigned} dropdownData={metricUnassignedDropdownData} onChange={onMetricUnassignedTableChange} selectMenu={false} onBottom={() => ''}></ManageTable>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default Main